import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES, OPTION_STATUS } from "@miplatform/constants";
import {
  createUUID,
  sortByOptionStatus,
  sortMaterialResponse,
} from "@miplatform/utils";

export const usePlanAreaOptionViewModel = ({ area, stateManager }) => {
  const [materialsData, setMaterialsData] = useState([]);

  const GET_MATERIALS_UUID = createUUID();

  const getMaterials = () => {
    stateManager.abort(GET_MATERIALS_UUID);
    stateManager.run(async () => {
      const planAreaMaterialId =
        area?.materials?.map((m) => m.materialId) ?? [];

      const response = await homeService.materials.getAll({
        filters: {
          id: { in: { type: "guid", value: planAreaMaterialId } },
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        const mappedData = area?.materials?.map((material) => {
          const materialDetails = response.data.find(
            (item) => item.id === material.materialId
          );
          return {
            ...materialDetails,
            ...material,
            optionStatus: material.optionStatus ?? OPTION_STATUS.EXISTING,
          };
        });

        const displayOrderSortedData = sortMaterialResponse(mappedData);
        const optionStatusSortedData = sortByOptionStatus(
          displayOrderSortedData
        );
        setMaterialsData(optionStatusSortedData);
      }
    }, GET_MATERIALS_UUID);
  };

  return {
    getMaterials,
    setMaterialsData,
    materialsData,
  };
};
